
import {
	Box, Container, Divider, LinearProgress,
	makeStyles, Typography, Grid
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import Page from 'src/components/Page';
import { useActions, useValues } from 'kea';

import alertlogic from 'src/store/alert';
import vehiclelogic from 'src/store/vehicle';
import profilelogic from 'src/store/profile';

import checkRole from '../../utils/checkRole';
import CreateAlertDialog from './Toolbar/CreateDialog';

import DefaultResult from './Default';
import Toolbar from './Toolbar';
import ServiceResult from './Service';
import TemperatureResult from './Temperature';
import StolenResult from './Stolen';
import TamperResult from './Tamper';

//TODO clean styles
const useStyles = makeStyles((theme) => ({
	root: {
		backgroundColor: theme.palette.background.dark,
		minHeight: "100%",
		paddingBottom: theme.spacing(3),
		paddingTop: theme.spacing(3),
	},
	card: {},
}));

let all_columns = [
	{
		field: "enabled",
		headerName: "Enabled",
		align: "left",
		width: 50,
	},
	{
		field: "registration",
		headerName: "Registration",
		align: "left",
		width: 200,
	},
	{
		field: "type",
		headerName: "Type",
		align: "left",
		width: 80,
	},
	{
		field: "name",
		headerName: "Name",
		align: "left",
		width: 150,
	},
];

let action_column = [
	{
		field: "actions",
		align: "right",
		headerName: "Actions",
		width: 100,
	},
]

let speed_columns = [

]

let stolen_columns = [
	// {
	// 	field: "last_updated",
	// 	align: "left",
	// 	headerName: "Last Updated",
	// 	width: 120,
	// },
	// {
	// 	field: "last_location",
	// 	align: "left",
	// 	headerName: "Last Location",
	// 	width: 200,
	// },
	// {
	// 	field: "online_status",	//online or offline
	// 	align: "left",
	// 	headerName: "Online Status",
	// 	width: 100,
	// },
]

let service_columns = [
	{
		field: "last_updated",
		align: "left",
		headerName: "Last Updated",
		width: 100,
	},
	{
		field: "current_kms",
		align: "left",
		headerName: "Current Kms",
		width: 100,
	},
	{
		field: "last_serviced",
		align: "left",
		headerName: "Last Service",
		width: 100,
	},
	{
		field: "service_status",	//good or overdue
		align: "left",
		headerName: "Status",
		width: 100,
	},
]

let temperature_columns = [
	{
		field: "last_updated",
		align: "left",
		headerName: "Last Updated",
		width: 150,
	},
	{
		field: "current_temp",
		align: "left",
		headerName: "Current Temperature",
		width: 100,
	},
	{
		field: "current_status", //good or bad
		align: "left",
		headerName: "Status",
		width: 100,
	},
]

const AlertView = () => {
	const classes = useStyles();

	const { alerts } = useValues(alertlogic);
	const { fetchAll: AlertFetchAll } = useActions(alertlogic);

	const { vehicles } = useValues(vehiclelogic);
	const { fetchAll: VehicleFetchAll } = useActions(vehiclelogic);

	const { profile, } = useValues(profilelogic);

	const [selectedAlert, setSelectedAlert] = useState(null);

	useEffect(() => {
		alerts ?? AlertFetchAll();
		vehicles ?? VehicleFetchAll();
	}, []); // eslint-disable-line


	const handle_select_filter = (index) => {
		setSelectedAlert(alerts[index] || null);
	}

	const RenderResult = (type) => {
		let col;
		switch (type) {
			case 'speed':
				col = all_columns.concat(speed_columns);
				if (checkRole(profile, ['AlertEdit'])) col = col.concat(action_column);
				return <DefaultResult selectedAlert={selectedAlert} columns={col} />
			case 'tamper':
				col = all_columns.concat(stolen_columns);
				if (checkRole(profile, ['AlertEdit'])) col = col.concat(action_column);
				return <TamperResult selectedAlert={selectedAlert} columns={col} />
			case 'stolen':
				col = all_columns.concat(stolen_columns);
				if (checkRole(profile, ['AlertEdit'])) col = col.concat(action_column);
				return <StolenResult selectedAlert={selectedAlert} columns={col} />
			case 'service':
				col = all_columns.concat(service_columns);
				if (checkRole(profile, ['AlertEdit'])) col = col.concat(action_column);
				return <ServiceResult selectedAlert={selectedAlert} columns={col} />
			case 'temperature':
				col = all_columns.concat(temperature_columns);
				if (checkRole(profile, ['AlertEdit'])) col = col.concat(action_column);
				return <TemperatureResult selectedAlert={selectedAlert} columns={col} />
			default:
				return <DefaultResult selectedAlert={selectedAlert} columns={all_columns.concat(action_column)} />
		}
	}

	if (alerts === null || vehicles === null) {
		return (
			<></>
		)
	}

	return (
		<Page
			className={classes.root}
			title="Alerts"
		>
			<Container maxWidth={false}>
				<Box mt={3} >
					<Typography variant="h3" gutterBottom>
						Alerts
					</Typography>
					<Divider />
				</Box>
				<Box display="flex" flexDirection="row">
					<Toolbar selectedAlert={selectedAlert} select_filter={handle_select_filter} rows={alerts} />
					<Box ml="auto" style={{ paddingTop: "15px" }}>
						{checkRole(profile, ['AlertEdit']) && <CreateAlertDialog />}
					</Box>
				</Box>
				{
					selectedAlert &&
					<Box mt={3}>
						<Grid container spacing={1}>
							<Grid item xs={12} sm={12} md={12} lg={12}>
								{RenderResult(selectedAlert.condition.monitor)}
							</Grid>
						</Grid>
					</Box>
				}
			</Container>
		</Page>
	);
};

export default AlertView;
